<template>
  <div>
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <el-input :class="{onlyread:component.properties.readonly}" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-login-user',
  props: ['initComponent'],
  inject: ['formService'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  },
  methods: {
    // 自身移除时移除所有子控件
    remove () {
      for (let attr in this.component.properties.loginUser) {
        if (this.component.properties.loginUser[attr] && this.component.properties.loginUser[attr] !== '') {
          let component = this.formService.getComponentById(this.component.properties.loginUser[attr])
          this.formService.removeComponent(component)
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/form/components/login-user/rc-login-user.vue